import styled from 'styled-components';

export const ModalContent = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
    height: 80%;

    h1.new-package {
        font: italic bold 24px 'Roboto Condensed';
        text-align: center;
        color: #fff;
        text-transform: uppercase;
        span{color: #acff24; font-size: 20px;}
    }
    h2.pricing {
        font: italic bold 20px 'Roboto Condensed';
        color: #fff;
        text-transform: uppercase;
        text-align: center;
        span {color: #acff24; font-size: 18px;}
    }

    button.switch-package {padding: .5em 2em;}
`

export const FeatureColumn = styled.div`
    display: flex;
    flex-direction: column;
    align-items: ${props => props.align ? props.align : 'flex-start'};
    width: ${props =>  props.width ? props.width : '50%'};
    padding: ${props => props.padding ? props.padding : ''};
    padding-right: ${props => props.padding ? '4em': ''};
    background-color: ${props => props.backgroundColor ? props.backgroundColor : 'transparent'};
    h1.page-heading {
        font: italic bold 48px 'Roboto Condensed';
        text-transform: uppercase;
        margin-left: 1em;
        margin-bottom: 0.75em;
    }
    h1.feature-head {
        font: italic bold 36px 'Roboto Condensed';
        text-transform: uppercase;
        margin-left: 1em;
    }
    p.feature-detail {
        font: normal normal 18px 'Roboto Condensed';
        margin-left: 2em;
        span{color: #acff24;}
    }

    img.feature-banner {
        width: 100%;
        min-width: 360px;
    }
    button.upgrade-now {margin-left: 2em; padding: .5em 1em; margin-top: 1em;}
    p.upgrade-testimonial {
        font: italic bold 24px 'Roboto Condensed';
        text-align: left;
        text-transform: uppercase;
    }
    p.testimonial-own {
        color: #acff24;
        font-size: 20px;
        font-weight: bold;
        font-style: italic;
        text-transform: uppercase;
    }
`
export const SectionHeader = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center; margin: 2em 0;
    text-transform: uppercase;

    h2.section-heading {
        font: italic bold 36px 'Roboto Condensed';
        text-align: center;
    }
    h2.section-subheading {
        font: italic bold 26px 'Roboto Condensed';
        color: #acff24;
        text-align: center;
    }
`


// WEBPACK FOOTER //
// ./src/pages/Profile/UpdateSubscription/UpdateSubscription.styles.ts